import React from "react";
import ArrowRightIcon from "images/icons/arrow-right-big-icon.inline.svg";
import { Link } from "gatsby";

const NewToGvi = () => {
  return (
    <Link to={"/about-us"} className="newToGvi-link">
      <div className="dark:bg-gray-standard bg-generic-bg px-4 py-2 rounded-xs">
        <div className="flex items-center justify-between">
          <p className="dark:text-white text-black-lighter">New to GVI?</p>
          <ArrowRightIcon className="hidden fill-green-standard dark:block icon-go" />
          <ArrowRightIcon className="block fill-yellow-lighten dark:hidden icon-go" />
        </div>
        <p className="dark:text-gray-lighter text-black-lighter">
          Find out what we’re about
        </p>
      </div>
    </Link>
  );
};

export default NewToGvi;
